import { render } from "./Privacy.vue?vue&type=template&id=2ff20523"
const script = {}

import "./Privacy.vue?vue&type=style&index=0&id=2ff20523&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__